import React from "react";
import { BookOpenIcon, BookmarkIcon, ClockIcon, CompassIcon, RepeatIcon, WeightIcon, BoxIcon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { CtaButton } from "../CtaButton";
import { situations } from "../../data/content";
const icons: Record<(typeof situations)[number]['icon'], BoxIcon> = {
  compass: CompassIcon,
  clock: ClockIcon,
  bookmark: BookmarkIcon,
  weight: WeightIcon,
  repeat: RepeatIcon,
  book: BookOpenIcon
};
export function Situations() {
  return <section className="bg-sand px-5 py-16 sm:py-24" data-id="element-303" data-mp="2ei1zzj4nqr75">
      <div className="mx-auto max-w-6xl" data-id="element-304" data-mp="2eko8bkzdhaqf">
        <SectionHeading eyebrow="Do you recognize yourself?" title={<>
              Do any of these situations <em className="text-brand-700" data-id="element-306" data-mp="25ievgogmt59v">sound like you?</em>
            </>} data-id="element-305" data-mp="2afyd7ycjg06k" />
        <div className="mt-10 grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-307" data-mp="8p3gn4aibwys">
          {situations.map(s => {
          const Icon = icons[s.icon];
          return <article key={s.quote} className="flex flex-col rounded-2xl bg-white p-6" data-id="element-308" data-mp="3r1uublp5jjm">
                <span className="grid h-11 w-11 place-items-center rounded-xl bg-brand-100 text-brand-700" data-id="element-309" data-mp="133jup3j1xywm">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-310" data-mp="185hk6fi1ppy0" />
                </span>
                <h3 className="mt-4 font-display text-xl font-bold italic leading-snug text-ink" data-id="element-311" data-mp="u5zr3nxpvqiu">“{s.quote}”</h3>
                <p className="mt-3 text-[16px] leading-relaxed text-ink-soft" data-id="element-312" data-mp="z3rsr9o5yr08">{s.text}</p>
              </article>;
        })}
        </div>
        <CtaButton label="I’m ready to stop improvising" className="mt-12" data-id="element-313" data-mp="1quftwlpu7wdw" />
      </div>
    </section>;
}